if (!customElements.get('product-modal')) {
  customElements.define(
    'product-modal',
    class ProductModal extends ModalDialog {
      constructor() {
        super();
        this._controlsBound = false;
      }

      hide() {
        super.hide();
      }

      show(opener) {
        super.show(opener);
        this.showActiveMedia();
        this._initControls();
      }

      showActiveMedia() {
        const content = this.querySelector('[role="document"]');
        if (!content) return;

        // opener 的 data-media-id 格式可能是 "sectionId-mediaId"
        // product-media.liquid 输出的 img 是纯数字 mediaId
        // 统一提取纯数字部分，确保两者能匹配
        let openedByMediaId = this.openedBy.getAttribute('data-media-id');
        if (openedByMediaId && openedByMediaId.includes('-')) {
          openedByMediaId = openedByMediaId.split('-').pop();
        }

        // 取消所有直接子元素的 active
        Array.from(content.children).forEach((el) => {
          el.classList.remove('active');
        });

        // 找到对应的 media 元素并激活
        const activeMedia = Array.from(content.children).find(
          (el) => el.getAttribute('data-media-id') === openedByMediaId
        );
        if (!activeMedia) return;

        const activeMediaTemplate = activeMedia.querySelector('template');
        const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;

        activeMedia.classList.add('active');

        const container = content;
        container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

        if (
          activeMedia.nodeName == 'DEFERRED-MEDIA' &&
          activeMediaContent &&
          activeMediaContent.querySelector('.js-youtube')
        )
          activeMedia.loadContent();

        // 同步底部缩略图（用纯数字 ID 匹配）
        this._syncThumbnailById(openedByMediaId);
        this._updateMediaCount();
      }

      _getMediaItems() {
        const content = this.querySelector('[role="document"]');
        if (!content) return [];
        return Array.from(content.children);
      }

      _getActiveMedia() {
        const content = this.querySelector('[role="document"]');
        if (!content) return null;
        return Array.from(content.children).find(
          (el) => el.classList.contains('active')
        ) || null;
      }

      _updateMediaCount() {
        this.setAttribute('data-media-count', this._getMediaItems().length);
      }

      _activateMedia(mediaEl) {
        if (!mediaEl) return;
        const content = this.querySelector('[role="document"]');
        if (!content) return;

        Array.from(content.children).forEach((el) => el.classList.remove('active'));
        mediaEl.classList.add('active');

        // data-media-id 在直接子元素上，直接取
        const mediaId = mediaEl.getAttribute('data-media-id');
        this._syncThumbnailById(mediaId);
      }

      _syncThumbnailById(mediaId) {
        if (!mediaId) return;

        // mediaId 此时是纯数字
        // 缩略图的 data-media-id 也是纯数字（{{ media.id }}）
        const thumbs = Array.from(
          this.querySelectorAll('.product-media-modal__thumb')
        );

        let activeThumb = null;
        thumbs.forEach((thumb) => {
          const isMatch = thumb.getAttribute('data-media-id') === mediaId;
          thumb.classList.toggle('is-active', isMatch);
          if (isMatch) activeThumb = thumb;
        });

        if (!activeThumb) return;

        const strip = this.querySelector('.product-media-modal__thumbnails');
        if (!strip) return;

        const thumbLeft = activeThumb.offsetLeft;
        const thumbWidth = activeThumb.offsetWidth;
        const stripScrollLeft = strip.scrollLeft;
        const stripWidth = strip.clientWidth;

        if (thumbLeft < stripScrollLeft) {
          strip.scrollTo({ left: thumbLeft - 8, behavior: 'smooth' });
        } else if (thumbLeft + thumbWidth > stripScrollLeft + stripWidth) {
          strip.scrollTo({
            left: thumbLeft + thumbWidth - stripWidth + 8,
            behavior: 'smooth',
          });
        }
      }

      _navigate(direction) {
        const items = this._getMediaItems();
        if (items.length <= 1) return;

        const activeMedia = this._getActiveMedia();
        const currentIndex = activeMedia ? items.indexOf(activeMedia) : 0;

        let nextIndex = currentIndex + direction;
        if (nextIndex < 0) nextIndex = items.length - 1;
        if (nextIndex >= items.length) nextIndex = 0;

        this._activateMedia(items[nextIndex]);
      }

      _initControls() {
        if (this._controlsBound) return;
        this._controlsBound = true;

        const prevBtn = this.querySelector('.product-media-modal__arrow--prev');
        const nextBtn = this.querySelector('.product-media-modal__arrow--next');
        const thumbStrip = this.querySelector('.product-media-modal__thumbnails');
        const contentArea = this.querySelector('[role="document"]');

        // pointerup 阻止冒泡，防止触发 ModalDialog 的关闭逻辑
        if (contentArea) {
          contentArea.addEventListener('pointerup', (e) => {
            e.stopPropagation();
          });
        }

        [prevBtn, nextBtn].forEach((btn) => {
          if (!btn) return;
          btn.addEventListener('pointerup', (e) => {
            e.stopPropagation();
          });
        });

        if (thumbStrip) {
          thumbStrip.addEventListener('pointerup', (e) => {
            e.stopPropagation();
          });
        }

        // 左箭头
        if (prevBtn) {
          prevBtn.addEventListener('click', (e) => {
            e.stopPropagation();
            this._navigate(-1);
          });
        }

        // 右箭头
        if (nextBtn) {
          nextBtn.addEventListener('click', (e) => {
            e.stopPropagation();
            this._navigate(1);
          });
        }

        // 缩略图点击
        if (thumbStrip) {
          thumbStrip.addEventListener('click', (e) => {
            const thumb = e.target.closest('.product-media-modal__thumb');
            if (!thumb) return;
            e.stopPropagation();

            const targetMediaId = thumb.getAttribute('data-media-id');
            if (!targetMediaId) return;

            const content = this.querySelector('[role="document"]');
            if (!content) return;

            // 缩略图 data-media-id 是纯数字，直接子元素也是纯数字，直接匹配
            const targetMedia = Array.from(content.children).find(
              (el) => el.getAttribute('data-media-id') === targetMediaId
            );
            this._activateMedia(targetMedia);
          });
        }

        // 键盘方向键
        this.addEventListener('keydown', (e) => {
          if (e.key === 'ArrowLeft') {
            e.preventDefault();
            this._navigate(-1);
          }
          if (e.key === 'ArrowRight') {
            e.preventDefault();
            this._navigate(1);
          }
        });
      }
    }
  );
}
